import * as Yup from 'yup'

export const validationSchema = Yup.object({
  facade_materials: Yup.array().min(1),
  facade_manufacturer_id: Yup.string().nullable().required(),
  facade_system_id: Yup.string().nullable().required(),
})
